'use strict';
var anObject = require('./_an-object');
var toPrimitive = require('./_to-primitive');
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};



//////////////////
// WEBPACK FOOTER
// ../~/core-js/modules/_date-to-primitive.js
// module id = 1260
// module chunks = 1